import axios from "axios";
import { auth, authStateKnown } from "../helper/firebaseClient";

const apiEndpoint = process.env.REACT_APP_BACKEND_BASE_URL;

if (!apiEndpoint) throw new Error("Are you sure about the api url env");

/**
 * @name Axios Interceptor
 * @description Pre fills access token for every call
 */
const api = axios.create({
  baseURL: apiEndpoint,
});

api.interceptors.request.use(
  async (config) => {
    await authStateKnown;
    const user = auth.currentUser;
    console.log("Axios auth user:", auth.currentUser);
    if (user) {
      try {
        const token = await user.getIdToken();
        console.log({ token });
        if (token) {
          // config.headers.Authorization = `Bearer ${token}`;
          config.headers.Authorization = token;
        }
      } catch (error) {
        console.error("Error fetching token:", { error });
      }
    }

    // if (!user) return config;

    return config;
  },
  (error) => Promise.reject(error),
);

// The backend answers 403 {code: "subscription_expired"} to every non-billing
// call once an org's subscription has lapsed. Tell the app so it re-fetches the
// profile and ProtectedRoute can send the admin to /checkout. A window event is
// used (instead of importing the auth store) to avoid a circular import.
const handleSubscriptionExpired = (error) => {
  if (
    error?.response?.status === 403 &&
    error?.response?.data?.code === "subscription_expired"
  ) {
    window.dispatchEvent(new Event("subscription-expired"));
  }
  return Promise.reject(error);
};

api.interceptors.response.use(
  (response) => response,
  handleSubscriptionExpired,
);
// Some screens use the global axios instance directly.
axios.interceptors.response.use(
  (response) => response,
  handleSubscriptionExpired,
);

export { api };
  